import React from 'react';
import moment from 'moment';
//import Currency from 'react-currency-formatter';
import api from '~/services/api';
//import { toast } from 'react-toastify';
//import { connect } from 'react-redux';
//import { bindActionCreators } from 'redux';
//import { Creators as InvoiceActions } from '~/store/ducks/invoice';

import {
  Container,
  Title,
  ItemDetails,
  Left,
  Right,
  DownloadIcon,
  DownloadButton,
  Divisor,
  //Details,
  //IconInformation,
  Column,
  BoxTitle,
  Dates,
  DesktopContent,
  MobileContent
} from './styles';
//import information from '~/assets/images/information.svg';
//import ModalContracts from "~/components/pages/Contracts/Modal";

export default function Item({
  index,
  contract,
  showModal,
  activeModal,
  setContractChoosed,
  setindexChoosed,
  downloadGone,
  setDownloadGone,
}) {

  function getContracts() {
    setDownloadGone(true);
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
      client_id: process.env.REACT_APP_CLIENT_ID
    };

    const parameters = {
      method: 'GET',
      headers: header,
    };

    const url = `/residential/store/v1/stores/${localStorage.getItem(
      "storeId"
    )}/attachments/${contract.attachmentId}`;

    api.get(url, parameters)
    .then((res) => {
      dowloadContent(res.data.attachment)
    })
    .catch((err) => {})
  }

  function dowloadContent(file) {
    const linkSource = `data:application/pdf;base64,${file}`;
    const downloadLink = document.createElement("a");
    const fileName = `${contract.contractType}-${index + 1}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    setDownloadGone(false);
  }

  return (
    <Container className="mb-3">
      <DesktopContent>
        <Left>
          <Column>
            <Title style={{ fontWeight: "550" }}>
              {contract.contractType} {index + 1}
            </Title>
          </Column>
          <Dates>
            <Column style={{ marginLeft: 20 }}>
              <Title style={{ fontSize: 14 }}>Início:</Title>
              <ItemDetails>
                {moment(contract.beginDate, "YYYY-MM-DD").format("DD/MM/YYYY")}
              </ItemDetails>
            </Column>
            <Column style={{ marginLeft: 20 }}>
              <Title style={{ fontSize: 14 }}>Vencimento:</Title>
              <ItemDetails>
                {moment(contract.endDate, "YYYY-MM-DD").format("DD/MM/YYYY")}
              </ItemDetails>
            </Column>
          </Dates>
        </Left>
        <Right>
          <DownloadButton className="mr-2">
            {
              downloadGone ? (
                <i
                  className="fa fa-spinner fa-pulse fa-1x fa-fw"
                  style={{ color: "#000FFF", marginTop: ".6rem" }}
                />
              ) : (
                <DownloadIcon
                  className="mdi mdi-download"
                  onClick={() => getContracts()}
                />
              )
            }
          </DownloadButton>
          <DownloadButton>
            <DownloadIcon
              className="mdi mdi-eye"
              onClick={() => {
                setContractChoosed(contract);
                setindexChoosed(index);
                activeModal(true);
              }}
            />
          </DownloadButton>
          <Divisor />
          <BoxTitle>
            <Title style={{ fontSize: 13 }}>
              {contract.contractNumber}
            </Title>
          </BoxTitle>
        </Right>
      </DesktopContent>

      <MobileContent>
        <Left>
          <Title style={{ fontWeight: "550" }}>
            {contract.contractType} {index + 1}
          </Title>
          <Column>
            <Title style={{ fontSize: 13 }}>Início:</Title>
            <ItemDetails>
              {moment(contract.beginDate, "YYYY-MM-DD").format("DD/MM/YYYY")}
            </ItemDetails>
          </Column>
          <Column>
            <Title style={{ fontSize: 13 }}>Vencimento:</Title>
            <ItemDetails>
              {moment(contract.endDate, "YYYY-MM-DD").format("DD/MM/YYYY")}
            </ItemDetails>
          </Column>
        </Left>
        <Right>
          <Title style={{ fontSize: 12 }}>
            {contract.contractNumber}
          </Title>
          <div style={{
            display: "flex",
            justifyContent: "space-around"
          }}>
            <DownloadButton className="mr-2">
            {
              downloadGone ? (
                <i
                  className="fa fa-spinner fa-pulse fa-1x fa-fw"
                  style={{ color: "#000FFF", marginTop: ".6rem" }}
                />
              ) : (
                <DownloadIcon
                  className="mdi mdi-download"
                  onClick={() => getContracts()}
                />
              )
            }
            </DownloadButton>
            <DownloadButton>
              <DownloadIcon
                className="mdi mdi-eye"
                onClick={() => {
                  setContractChoosed(contract);
                  setindexChoosed(index);
                  activeModal(true);
                }}
              />
            </DownloadButton>
          </div>
        </Right>
      </MobileContent>
    </Container>
  );
}
